<template>
  <div class="mb-5">
    <CRow>
      <CCol md="12">
        <CCardHeader class="p-1">
          <CRow>
            <CCol col="6" style="text-align: start ;padding:10px 20px 0 20px ">

              <strong>فیش حقوقی</strong>

            </CCol>
            <CCol col="6" style="text-align: end">

              <!--              <CButton v-if="items.length>0" @click="send_data()" size="sm"-->
              <!--                       color="secondary"-->
              <!--                       class="mr-1">-->
              <!--                ذخیره تغییرات اطلاعات-->
              <!--              </CButton>-->
              <CButton v-if="items.length>0" @click="generateReport(1)" size="sm"
                       color="secondary"
                       class="mr-1">
                دریافت pdf
              </CButton>

            </CCol>
          </CRow>
        </CCardHeader>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="8">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                <strong>انتخاب کامند</strong>
              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol>
                <CSelect
                    :options="personnel_list"
                    :value.sync="selected_personnel"
                    color="secondary">
                  کارمند
                </CSelect>

              </CCol>
              <CCol>
                <date-picker
                    type="month"
                    label="ماه"
                    v-model="month"/>

              </CCol>
              <CCol>
                <date-picker
                    type="year"
                    label="سال"
                    v-model="year"/>

              </CCol>
              <CCol>
                <CButton
                    color="dark"
                    @click="get_data_detail()"
                    size="sm"
                >
                  <CIcon name="cil-zoom"/>
                </CButton>
              </CCol>
            </CRow>
            <CRow>
              <!--              <CCol>-->
              <!--                <CInputCurrency-->
              <!--                  v-model="sanavat"-->
              <!--                  label="سنوات"/>-->
              <!--              </CCol>-->
              <CCol>
                <CInputCurrency
                    v-model="mosaede"
                    label="مساعده"/>
              </CCol>
              <CCol>
                <CInputCurrency
                    v-model="vam"
                    label="وام"/>
              </CCol>


            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

    </CRow>
    <CRow>
      <CCol>
        <CCard id="data_container" class="no-row-margin m-4">
          <CCardBody v-if="items.length>0">
            <CRow>
              <CCol style="text-align: center;font-size: 24px">
                <strong>فیش حقوقی پرسنل قراردادی {{ settings_value.company_name }}</strong>

              </CCol>
            </CRow>

            <CRow>
              <CCol col="12">
                <CRow class="border-1 header-box">
                  <CCol col="4">
                    آقای / خانم:
                    {{ user_data.first_name }} {{ user_data.last_name }}
                  </CCol>
                  <CCol col="4">
                    کد ملی:
                    {{ user_data.national_code }}
                  </CCol>
                  <CCol col="4">
                    ماه:
                    {{ get_month_string() }}
                    سال:
                    {{ year }}
                  </CCol>
                  <CCol col="4">
                    بانک:
                  </CCol>
                  <CCol col="4">
                    شماره حساب:
                  </CCol>
                  <CCol col="4">
                    تعداد فرزند:
                    {{ user_data.child_no }}
                  </CCol>
                </CRow>
                <CRow>
                  <CCol class="border-1" col="4">
                    <div class="header-box">کارکرد</div>
                    <div class="left-right-items">
                      <div>حقوق پایه</div>
                      <div>{{ get_currency(settings_value.base_salary) }}</div>
                      <div>تومان</div>
                    </div>
                    <div class="left-right-items">
                      <div>حقوق روزانه</div>
                      <div>{{ get_currency(settings_value.daily_salary) }}</div>
                      <div>تومان</div>
                    </div>
                    <div class="left-right-items">
                      <div>کارکرد عادی</div>
                      <div>{{ month_day() }}</div>
                      <div>روز</div>
                    </div>
                    <div class="left-right-items">
                      <div>کارکرد موثر</div>
                      <div>{{ karkard_moaser()}}</div>
                      <div>روز</div>
                    </div>
                    <div class="left-right-items">
                      <div>هر ساعت اضافه کار</div>
                      <div>{{ get_currency(settings_value.extra_hour_payment) }}</div>
                      <div>تومان</div>
                    </div>
                    <div class="left-right-items">
                      <div>اضافه کاری</div>
                      <div>{{ secondsToString(monthly_total_extra) }}</div>
                      <div>ساعت</div>
                    </div>
                    <div class="left-right-items">
                      <div>حق مسکن</div>
                      <div>{{ get_currency(settings_value.housing_payment) }}</div>
                      <div>تومان</div>
                    </div>
                    <div class="left-right-items">
                      <div>حق اولاد</div>
                      <div>{{ get_currency(user_data.child_no) }}</div>
                      <div>تومان</div>
                    </div>
<!--                    <div class="left-right-items">-->
<!--                      <div>حق خواروبار</div>-->
<!--                      <div>{{ get_currency(settings_value.grocery_payment) }}</div>-->
<!--                      <div>تومان</div>-->
<!--                    </div>-->
                    <div class="left-right-items">
                      <div>حق تاهل</div>
                      <div>{{ get_currency(settings_value.married_payment) }}</div>
                      <div>تومان</div>
                    </div>
                    <div class="left-right-items">
                      <div>بن کارگری</div>
                      <div>{{ get_currency(settings_value.working_payment) }}</div>
                      <div>تومان</div>
                    </div>

                  </CCol>
                  <CCol class="border-1" col="4">
                    <div class="header-box">حقوق و مزایا</div>
                    <div class="left-right-items">
                      <div >حقوق ماهانه</div>
<div >{{ get_currency(base_monthly_salary())}}</div>

                    </div>
                    <div class="left-right-items">
                      <div>کمک هزینه مسکن</div>
                      <div v-if="!is_one_month_contract()">{{ get_currency(settings_value.housing_payment) }}</div>
                      <div v-else>0</div>

                      <div></div>
                    </div>
<!--                    <div class="left-right-items">-->
<!--                      <div >حق خواروبار</div>-->

<!--                      <div v-if="!is_one_month_contract()">{{ get_currency(settings_value.grocery_payment) }}</div>-->
<!--                      <div v-else>0</div>-->

<!--                      <div></div>-->
<!--                    </div>-->
                    <div class="left-right-items">
                      <div >حق تاهل</div>

                      <div v-if="user_data.married">{{ get_currency(settings_value.married_payment) }}</div>
                      <div v-else>0</div>

                      <div></div>
                    </div>
                    <div class="left-right-items">
                      <div>حق اولاد</div>
                      <div v-if="!is_one_month_contract()">

                        {{ get_currency(parseInt(settings_value.children_payment) * parseInt(user_data.child_no)) }}
                      </div>
                      <div v-else>0</div>

                      <div></div>
                    </div>
                    <div class="left-right-items">
                      <div >بن کارگری</div>
                      <div v-if="!is_one_month_contract()">{{ get_currency(settings_value.working_payment) }}</div>
                      <div v-else>0</div>

                      <div></div>
                    </div>
                    <div class="left-right-items">
                      <div>حق سنوات</div>
                      <div v-if="!is_one_month_contract()">{{ get_currency(sanavat) }}</div>
                      <div v-else>0</div>
                      <div></div>
                    </div>

                    <div class="left-right-items">
                      <div>پاداش تولید</div>
                      <div>0</div>
                      <div></div>
                    </div>
                    <div class="left-right-items">
                      <div>مزایای مشمول</div>
                      <div>0</div>
                      <div></div>
                    </div>
                    <div class="left-right-items" >
                      <div style="background: #d4d4d4">جمع کل</div>

                      <div v-if="!is_one_month_contract()" style="background: #d4d4d4"> {{
                          get_currency(total_calculate_salary() )
                        }}
                      </div>
                      <div v-else style="background: #d4d4d4">
                        {{get_currency(
                          ( settings_value.daily_salary*items.filter(x => x.times.length > 0).length)+
                          total_extra_price()
                      ) }}
                      </div>
<div ></div>
                    </div>

                    <div class="left-right-items">
                      <div>مابه التفاوت</div>
                      <div>{{get_currency(mabe_tafavot())}}</div>

                      <div></div>
                    </div>
                    <div class="left-right-items">
                      <div>اضافه کار</div>
                      <div >{{ get_currency(total_extra_price()) }}</div>
                      <div></div>
                    </div>


                  </CCol>
                  <CCol class="border-1" col="4">
                    <div class="header-box">کسورات</div>
                    <div class="left-right-items">
                      <div>بیمه سهم کارگر</div>
                      <div v-if="user_data.insurance==1">{{ get_currency(insurance_price()) }}</div>
                      <div v-else>0</div>
                      <div></div>
                    </div>
                    <div class="left-right-items">
                      <div>مالیات حقوق</div>
                      <div>0</div>
                      <div></div>
                    </div>
                    <div class="left-right-items">
                      <div>مساعده</div>
                      <div>{{ get_currency(mosaede) }}</div>
                      <div></div>
                    </div>
                    <div class="left-right-items">
                      <div>وام</div>
                      <div>{{ get_currency(vam) }}</div>
                      <div></div>
                    </div>
                    <div class="left-right-items">
                      <div>بدهی متفرقه</div>
                      <div>0</div>
                      <div></div>
                    </div>
                    <div class="left-right-items">
                      <div>کسر کار</div>
                      <div>{{ get_currency(total_subtract_price()) }}</div>
                      <div></div>
                    </div>
                    <div class="left-right-items">
                      <div>غیبت</div>
                      <div>0</div>
                      <div></div>
                    </div>


                  </CCol>

                  <CCol class="border-1" col="4">
                    <div class="header-box">مرخصی</div>

                  </CCol>
                  <CCol class="border-1" col="4">
                    <div class="header-box">

                      <div class="left-right-items">
                        <div>جمع کل مزایا</div>

                        <div v-if="!is_one_month_contract()">{{
                            get_currency(total_calculate_salary() + total_extra_price() + (parseInt(user_data.salary) - total_calculate_salary()))
                          }}
                        </div>
                        <div v-else >
                          {{get_currency(
                            ( settings_value.daily_salary*items.filter(x => x.times.length > 0).length)+
                        total_extra_price()
                        ) }}
                        </div>

                        <div></div>
                      </div>
                    </div>
                  </CCol>
                  <CCol class="border-1" col="4">
                    <div class="header-box">

                      <div class="left-right-items">
                        <div>جمع کل کسورات</div>
                        <div>{{ get_currency(total_kosorat_price()) }}</div>
                        <div></div>
                      </div>
                    </div>
                  </CCol>
                  <CCol class="border-1" col="4">

                    <div class="left-right-items">
                      <div>مرخصی سالانه</div>
                      <div>{{ morakhasi_hours() }} ساعت</div>
                    </div>
                    <div class="left-right-items">
                      <div>مرخصی استفاده شده</div>
                      <div>{{ calculate_total_morakhasi() }} ساعت</div>
                    </div>
                    <div class="left-right-items">
                      <div>مانده مرخصی</div>
                      <div>{{ morakhasi_hours() - calculate_total_morakhasi() }} ساعت</div>
                    </div>
                    <div class="header-box">
                      غیبت
                    </div>
                    <div class="left-right-items">
                      <div>غیبت</div>
                      <div>{{ items.filter(x => x.times.length == 0 && !x.onleave && !x.friday).length }} روز</div>
                    </div>
                    <div class="header-box">
                      تاخیر
                    </div>
                    <div class="left-right-items">
                      <div>تاخیر مجاز</div>
                      <div>{{ secondsToString(monthly_total_subtrac) }}</div>
                    </div>
                    <div class="left-right-items">
                      <div>تاخیر غیر مجاز</div>
                      <div> 0 ساعت</div>
                    </div>
                    <div class="left-right-items">
                      <div>مجموع تاخیر</div>
                      <div>{{ secondsToString(monthly_total_subtrac) }}</div>
                    </div>
                  </CCol>
                  <CCol class="border-1" col="8">
                    <div class="left-right-items" style="height: fit-content;
    padding: 15px;
    font-size: 16px;">
                      <div>خالص پرداختی</div>
                      <div >{{get_currency(pure_payment())}}
                      </div>

                      <div></div>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="m-2" style="display: inline-flex;
    justify-content: space-between;">
                <h6>
                  اینجانب
                  {{ user_data.first_name }} {{ user_data.last_name }}
                  تمامی حق و حقوق خود را دریافت نموده ام
                </h6>
                <h6>
                  امضا:
                </h6>
              </CCol>


            </CRow>
          </CCardBody>
        </CCard>

      </CCol>

    </CRow>
    <div>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          :filename="user_data.first_name+' '+user_data.last_name+' '+month+' '+year"
          :pdf-quality="2"
          margin="2"

          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          ref="html2Pdf"
      >
        <section slot="pdf-content">
          <!-- PDF Content Here -->
          <div id="pdf_container" class=" p-4 " style="width: 100%">

          </div>
        </section>
      </vue-html2pdf>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'Login',
  components: {
    VueHtml2pdf
  },
  data() {
    return {
      selected_personnel: 0,
      user_data: {},
      sanavat: '0',
      mosaede: '0',
      vam: '0',
      monthly_total_working: 0,
      monthly_total_subtrac: 0,
      monthly_total_extra: 0,
      settings_value: {},
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      month: '',
      year: '',
      file: null,
      all_leaves: [],
      export_file_name: '',
      export_modal: false,
      json_data: [],
      items: [],
      fields: [
        {key: 'row', label: 'ردیف', _style: 'width:10%'},
        {key: 'name', label: "کارمند", _style: 'width:20%'},
        {key: 'id', label: "شماره شناسه", _style: 'width:20%;'},
        {key: 'date', label: "تاریخ", _style: 'width:20%;'},

      ],
      shift_incoming_hour:'',
      shift_outgoing_hour:'',
      status_form: 0,
      selected_file_type: 0,
      personnel_list: [],
      settings: [],
    }
  }, mounted() {
    this.$root.root_validate_errors = [];
    this.month = moment().subtract(1, 'month').format('jMM')
    this.year = moment().format('jYYYY')
    this.get_personnel()
    this.get_settings()
  }, watch: {
    'selected_personnel': function () {
      this.get_salary_data()
    },
    'month': function () {
      this.get_salary_data()
    },
    'year': function () {
      this.get_salary_data()
    }
  },
  methods: {
    mabe_tafavot() {
      if(this.user_data.hourly_worker==1){
        return 0
      }
      if (!this.is_one_month_contract()) {
        return parseInt(this.user_data.salary) - (this.total_calculate_salary())
      }else{
        return 0
      }
    },
    pure_payment() {
      if (!this.is_one_month_contract()) {

        return this.total_calculate_salary()
            + this.mabe_tafavot()
                + (this.total_extra_price())
                - this.total_kosorat_price()

      }else {

        return (this.settings_value.daily_salary * this.items.filter(x => x.times.length > 0).length) +
                this.total_extra_price() -
                this.total_kosorat_price()


      }
    },
    base_monthly_salary() {

      if (!this.is_one_month_contract()) {
        return this.month_day() * this.settings_value.daily_salary
      } else {
        return this.settings_value.daily_salary * this.items.filter(x => x.times.length > 0).length
      }

    },
    morakhasi_hours() {
      var last_day = 31;
      if (parseInt(this.month) > 6) {
        last_day = 30
      }
      if (parseInt(this.month) == 12) {
        last_day = 29
      }
      // var con_date = new Date(this.user_data.contract_date)
      var con_date = new Date(this.user_data.contract_date)
      //    var con_month = (parseInt(con_date.getMonth())+1)
      //    if(con_month<10){
      //    con_month = "0"+con_month
      //    }
      // var first_con_date = new Date( con_date.getFullYear()+"-"+con_month+"-01")
      var diff_date =
          (con_date - new Date(moment(this.year + "-01" + this.month + "-01", "jYYYY-jMM-jDD").format('YYYY-MM-DD'))
              )
          / (30 * 24 * 60 * 60 * 1000)
      console.log("datediff", diff_date, new Date(this.user_data.contract_date) - new Date())
     diff_date = parseInt(diff_date)
      // return  diff_date*20
      if (diff_date < 0) {
        return 240
      }
      if (diff_date > 0) {
        return 240 - (diff_date*20);
      }
    },
    total_subtract_price() {
     if(this.user_data.hourly_worker==1){
       return 0;
     }
      if(this.settings_value.base_extra_work=='default'){
        var min_payment = parseInt(this.settings_value.extra_hour_payment) / 60;
        return (this.monthly_total_subtrac / 60) * min_payment;
      }else{
        var days = (this.monthly_total_subtrac / 3600) / parseInt(this.settings_value.every_hour_extra_one_day)
        var day_extra = this.user_data.salary / this.month_day()
        return parseInt(days * day_extra);
      }
    },
    total_extra_price() {
      if(this.user_data.hourly_worker==1){
        return 0;
      }
      if(this.settings_value.base_extra_work=='default'){
        var min_payment = parseInt(this.settings_value.extra_hour_payment) / 60;
        return (this.monthly_total_extra / 60) * min_payment;
      }else{
        var days = (this.monthly_total_extra / 3600) / parseInt(this.settings_value.every_hour_extra_one_day)
        var day_extra = this.user_data.salary / this.month_day()
        return parseInt(days * day_extra);
      }

    },
    total_kosorat_price() {
      var kosorat = this.total_subtract_price() +
          parseInt(this.vam) +
          parseInt(this.mosaede);
      if (this.user_data.insurance == 1) {
        kosorat += parseInt(this.insurance_price());
      }
      return kosorat
    },
    insurance_price(){
      var insurance_rate = this.month_day()* parseInt(this.settings_value.daily_salary)
      insurance_rate+=parseInt(this.settings_value.housing_payment)
      insurance_rate+=parseInt(this.settings_value.working_payment)
      if(this.user_data.married){
        insurance_rate += parseInt(this.settings_value.married_payment);
      }
    return   insurance_rate*0.07


    },
    total_calculate_salary() {

      var total = (this.month_day() * parseInt(this.settings_value.daily_salary)) +

        parseInt(this.settings_value.working_payment) +
          parseInt(this.settings_value.housing_payment)
          if(!this.is_one_month_contract()){
            total+=parseInt(this.sanavat) ;
          }
          // parseInt(this.settings_value.grocery_payment) +
          if(this.user_data.married){
            total += parseInt(this.settings_value.married_payment);
          }
          // this.total_extra_price()+

      total += (parseInt(this.settings_value.children_payment) * parseInt(this.user_data.child_no))

      if(this.user_data.hourly_worker==1){
        var month_hour = this.month_day()*8;
        return parseInt((this.monthly_total_working/3600) * (total/month_hour))
      }
      return total;
    },
    total_calculate_salary_without_sanavat() {
      var total = (this.month_day() * parseInt(this.settings_value.daily_salary)) +

          parseInt(this.settings_value.working_payment) +
          parseInt(this.settings_value.housing_payment) +
          // parseInt(this.settings_value.grocery_payment) +
          parseInt(this.settings_value.married_payment) +
          // this.total_extra_price()+

          (parseInt(this.settings_value.children_payment) * parseInt(this.user_data.child_no))
      return total;
    },
    get_month_string() {
      return moment(this.year + "-" + this.month + '-01', 'jYYYY-jMM-jDD').format('jMMMM')
    },
    generateReport(type) {
      if (type == 1) {
        document.getElementById("pdf_container").innerHTML = document.getElementById("data_container").innerHTML
        this.$refs.html2Pdf.generatePdf()
      } else {
        document.getElementById("pdf_container").innerHTML = document.getElementById("data_container_part2").innerHTML
        this.$refs.html2Pdf.generatePdf()
      }
      this.send_data()
    },
    month_day() {
      if (this.month == 12) {
        return 29;
      }
      if (this.month < 7) {
        return 31;
      } else {
        return 30
      }
    },
    calculate_all() {
      var self = this;
      var total_present = 0
      var total_extra = 0
      var total_subtrac = 0
      this.items.forEach(function (val) {
        total_present += self.calculate_present(val)
        total_extra += self.calculate_extra_work(val)
        total_subtrac += self.calculate_subtrac_work(val)
      })
      return [total_present, total_extra, total_subtrac];
    },
    calculate_present(item) {
      if (item.times.length == 0) {
        return 0;
      }

      var total = 0
      item.income_outgo.forEach(function (val, index) {
        if (val.outgo == '') {
          return 0;
        }
        var outgo = item.en_date + " " + val.outgo
        var income = item.en_date + " " + val.income
        total += new Date(outgo) - new Date(income);

      })
      return total / 1000;
    },
    calculate_extra_work(item) {
      if (item.times.length == 0) {
        return 0;
      }
      if (item.times.length % 2 == 1) {
        return 0;
      }
      // var start_hour = item.en_date + " " + this.settings.filter(x => x.setting_key == "incoming_hour")[0].setting_value + ":00"
      // var end_hour = item.en_date + " " + this.settings.filter(x => x.setting_key == "outgoing_hour")[0].setting_value + ":00"
      var start_hour = item.en_date + " " + this.shift_incoming_hour
      var end_hour = item.en_date + " " + this.shift_outgoing_hour
      var total_extra = 0;
      var total_work = new Date(end_hour) - new Date(start_hour);
      item.income_outgo.forEach(function (val, index) {
        if (val.outgo == '') {
          return 0;
        }
        var outgo = item.en_date + " " + val.outgo
        var income = item.en_date + " " + val.income
        if (item.friday == true) {
          total_extra += new Date(outgo) - new Date(income)
        } else {
          if (new Date(end_hour) < new Date(outgo) && new Date(end_hour) > new Date(income)) {
            total_extra += new Date(outgo) - new Date(end_hour)
          }
          if (new Date(end_hour) < new Date(outgo) && new Date(end_hour) < new Date(income)) {
            total_extra += new Date(outgo) - new Date(income)
          }
        }


        // total += new Date(outgo) - new Date(income);

      })
// var working_time = this.calculate_present(item) - (total_work/1000)
      return total_extra / 1000;
    },
    calculate_total_morakhasi() {
      // var start_hour = this.items[0].en_date + " " + this.settings.filter(x => x.setting_key == "incoming_hour")[0].setting_value + ":00"
      // var end_hour = this.items[0].en_date + " " + this.settings.filter(x => x.setting_key == "outgoing_hour")[0].setting_value + ":00"
      var start_hour = this.items[0].en_date + " " + this.shift_incoming_hour
      var end_hour = this.items[0].en_date + " " + this.shift_outgoing_hour
      var daily_work = new Date(end_hour) - new Date(start_hour);

      daily_work = daily_work / (1000 * 60 * 60);
      return this.all_leaves.length * daily_work
    },
    calculate_subtrac_work(item) {
      // var start_hour = item.en_date + " " + this.settings.filter(x => x.setting_key == "incoming_hour")[0].setting_value + ":00"
      // var end_hour = item.en_date + " " + this.settings.filter(x => x.setting_key == "outgoing_hour")[0].setting_value + ":00"
      var start_hour = item.en_date + " " + this.shift_incoming_hour
      var end_hour = item.en_date + " " + this.shift_outgoing_hour
      var daily_work = new Date(end_hour) - new Date(start_hour);

      daily_work = daily_work / 1000;

      if (item.times.length == 0) {

        if (item.friday == 0 && item.holiday == 0 && item.onleave == false) {
          return daily_work
        } else {
          return 0;

        }
      }
      // if (item.friday == 1 || item.holiday == 1 || item.onleave == true) {
      //   return 0
      // }
      var total = 0
      var val = item.income_outgo[0]
      if (val.outgo == '') {
        return 0;
      }
      var working = this.calculate_present(item);
      var extra = this.calculate_extra_work(item);
      //  daily_work =   new Date(end_hour) - new Date(start_hour);
      //
      // daily_work = daily_work/1000;8 - 11 - 11
      if(parseInt(working) - parseInt(extra) ==0 && parseInt(working)>0){
        return  0;
      }
      var wworking = parseInt(daily_work) - (parseInt(working) - parseInt(extra))
      if (wworking < 0) {
        return 0;
      }
      return wworking;
      // var income = item.en_date + " " + val.income
      // var outgo = item.en_date + " " + val.outgo
      // total += new Date(income) - new Date(start_hour);
      // // if(new Date(income) - new Date(start_hour))
      // if (total < 0) {
      //   return 0;
      // }
      //
      // return total / 1000;
    },
    karkard_moaser(){
    var moaser =  this.month_day()
       moaser -= this.items.filter(x =>  (x.friday || x.holiday) && new Date(this.user_data.contract_date) > new Date(x.en_date)).length
      moaser =moaser  - this.items.filter(x => x.times.length == 0 && !x.onleave && !x.friday && !x.holiday ).length
      return moaser
    },
    secondsToString(seconds) {
      var numhours = Math.floor(((seconds)) / 3600);
      var numminutes = Math.floor(((seconds) % 3600) / 60);
      if (numhours < 10) {
        numhours = '0' + numhours
      }
      if (numminutes < 10) {
        numminutes = '0' + numminutes
      }
      return numhours + ":" + numminutes

    },
    get_settings() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('/get_settings', formData, {}).then(function (response) {

        var content_data = response.data;
        self.settings = response.data;
        self.settings.forEach(function (val) {
          self.settings_value[val.setting_key] = val.setting_value
        })
      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_personnel() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('/get_personnels', formData, {}).then(function (response) {

        var content_data = response.data;
        self.personnel_list = [{label: 'انتخاب کارمند', value: 0}]
        // items = content_cats.orders;
        content_data.forEach(function (val) {
          self.personnel_list.push({label: val.first_name + " " + val.last_name, value: val.id})

        })


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    send_data() {
      var self = this;
      const formData = new FormData();
      var url = "insert_salary_data";

      // console.log("items",its);
      formData.append('user_id', this.selected_personnel);

      formData.append("year", this.year);
      formData.append("month", this.month);
      formData.append("mosaede", this.mosaede);
      formData.append("vam", this.vam);
      formData.append("sanavat", this.sanavat);
      axios.post(url, formData, {}).then(function (response) {

        // var content_data = response.data;


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_data_detail() {

      let self = this;
      const formData = new FormData();
      let url = "get_present_detail";

      formData.append('user_id', this.selected_personnel);
      formData.append('year', this.year);
      formData.append('month', this.month);

      axios.post(url, formData, {}).then((res) => {
        var start_time = ''
        var end_time = ''
        self.user_data = res.data.user_data
        self.shift_incoming_hour=  res.data.user_data.shift.start_time
        self.shift_outgoing_hour =  res.data.user_data.shift.end_time
        self.monthly_total_working = 0
        self.monthly_total_subtrac = 0
        self.monthly_total_extra = 0
        self.all_leaves = res.data.all_leaves;
        res.data.report.forEach(function (val) {
          val.income_outgo = []
          val.times.forEach(function (date, index) {
            const my_date = new Date(date.date);
            // date.time = my_date.getHours() + ":" + my_date.getMinutes()
            var min = my_date.getMinutes();
            var hour = my_date.getHours()
            if (min < 10) {
              min = '0' + min
            }
            if (hour < 10) {
              hour = '0' + hour
            }
            if (index % 2 == 0) {

              start_time = hour + ":" + min
            } else {
              end_time = hour + ":" + min
              val.income_outgo.push({
                income: start_time,
                outgo: end_time,

              })
              start_time = ''
              end_time = ''
            }
            // const my_date = new Date(date.date);
            // date.time = my_date.getHours() + ":" + my_date.getMinutes()
          })
          if (start_time != '') {
            val.income_outgo.push({
              income: start_time,
              outgo: end_time,
            })
            start_time = ''
            end_time = ''
          }
        })
        res.data.report.forEach(function (val) {
          self.monthly_total_working += self.calculate_present(val)
          self.monthly_total_subtrac += self.calculate_subtrac_work(val)
          self.monthly_total_extra += self.calculate_extra_work(val)

        })

        self.items = res.data.report
        var lenght_of_work = self.items.filter(x => x.income_outgo.length > 0).length
        var diff_date = (new Date(moment(this.year+"-"+this.month+"-01","jYYYY-jMM-jDD").format('YYYY-MM-DD')) -new Date(this.user_data.contract_date) )/ (365*24*60*60*1000)
        console.log(diff_date,new Date(this.user_data.contract_date) - new Date())
        // if(diff_date >= 1){
          this.sanavat = this.month_day() * parseInt(9400)
        // }
        if(diff_date >= 2){
          this.sanavat = this.month_day() * parseInt(18640)
        }if(diff_date >= 3){
          this.sanavat = this.month_day() * parseInt(22912)
        }if(diff_date >= 4){
          this.sanavat = this.month_day() * parseInt(43552)
        }if(diff_date >= 5){
          this.sanavat = this.month_day() * parseInt(56101)
        }
        // this.sanavat = diff_date
        // var san = (self.month_day() * parseInt(self.settings_value.daily_salary)) / 12;
        // san = san / self.month_day();
        // console.log("sanavat", san)
        //
        // this.sanavat = parseInt(san * lenght_of_work)
        // this.sanavat = "282000"
      })

          // axios.post(  '/admin/category', {
          //     name: self.name,
          //     description: self.description,
          //     image: self.image,
          //     cat: 0,
          // }).then(function (response) {
          //     self.name = '';
          //     self.description = '';
          //     // localStorage.setItem("api_token", response.data.access_token);
          //     // self.$router.push({ path: 'notes' });
          // })
          .catch(function (error) {
            console.log(error);
          });

    },
    is_one_month_contract() {
      if (this.user_data.leave_date == null) {
        return false;
      }
      var present = new Date(this.user_data.leave_date) - new Date(this.user_data.contract_date)
      let present_day = present / 60 / 60 / 24 / 1000;
      if (present_day < 30) {
        return true;
      } else {
        return false
      }


    },
    get_salary_data() {

      let self = this;
      const formData = new FormData();
      let url = "get_salary_data";

      formData.append('user_id', this.selected_personnel);
      formData.append('year', this.year);
      formData.append('month', this.month);

      axios.post(url, formData, {}).then((res) => {

        if (res.data.vam != null) {
          self.vam = res.data.vam;
          self.sanavat = res.data.sanavat;
          self.mosaede = res.data.mosaede;
        } else {
          self.vam = 0
          self.sanavat = 0
          self.mosaede = 0
        }
      })
          .catch(function (error) {
            console.log(error);
          });

    },

  }
}

</script>
<style>
.left-right-items {
  display: inline-flex;
  /*justify-content: space-between;*/
  width: 100%;
}

.left-right-items div:nth-child(2) {
  text-align: right;
}

.left-right-items div:first-child {
  text-align: right;
  width: 50% !important;

}

.left-right-items div:last-child {
  text-align: left;
}

.left-right-items div {
  /*display: inline-flex;*/
  /*justify-content: space-between;*/
  /*width: 100%;*/
  width: 25%;
  padding: 3px 9px 3px 4px;
}

.header-box {
  background: #d4d4d4;
  text-align: center;
}

.border-1 {
  border: 1px solid black;
  padding: 0;
}

.no-row-margin .row {
  margin: 0;
}
</style>
